import { Participant } from "../Models/Participant";
import Connector from "../SignalR/signalR-connection";

const { joinGroup } = Connector();

export async function fetchParticipants(votingId: string, setVotingDetails: React.Dispatch<any>) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_GETVOTING}${votingId}${process.env.REACT_APP_API_GETVOTINGCODE}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    setVotingDetails(data);

    return data.participants as Participant[];
  } catch (error) {
    console.error("Error fetching participants:", error);
    return [];
  }
}

export async function createNewParticipant(
  votingId: string,
  name: string,
  email: string,
  setcurrentParticipantId: React.Dispatch<React.SetStateAction<string | null>>
) {
  console.log("Added new Participant", name);

  const requestBody = {
    votingId: votingId,
    name: name,
    email: email,
  };

  try {
    const response = await fetch(`${process.env.REACT_APP_API_CREATEPARTICIPANT}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("New participant created:", data);
    setcurrentParticipantId(data.id);
    localStorage.setItem("ParticipantId", data.id);
    joinGroup(votingId);
  } catch (error) {
    console.error("Error creating new participant:", error);
  }
}
